// src/utils/request.js
import axios from "axios";

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // 默认 base API 地址
  timeout: 5000, // 超时时间
});

// 请求拦截器
service.interceptors.request.use(
  (config) => {
    // 可添加 token、loading 等逻辑
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

// 响应拦截器
service.interceptors.response.use(
  (response) => {
    const res = response.data;
    if (res.code !== 200) {
      // 使用 Vant 的 Toast 提示错误
      window.Toast.fail(res.message || "接口异常");
      return Promise.reject(new Error(res.message || "Error"));
    } else {
      return res;
    }
  },
  (error) => {
    window.Toast.fail("网络异常");
    return Promise.reject(error);
  }
);

export default service;
